import SnackbarUnstyled from '@mui/base/SnackbarUnstyled';
import PropTypes from 'prop-types';

import twclsx from 'utils/twclsx';

function Toast({ autoHideDuration, copy, extendedStyles, handleClose, nanoBannerVisible, open }) {
    const topMarginClass = nanoBannerVisible ? 'md:top-[170px]' : 'md:top-[100px]';

    return (
        <SnackbarUnstyled
            open={open}
            autoHideDuration={autoHideDuration}
            onClose={handleClose}
            slotProps={{
                root: {
                    className: twclsx(
                        'animate-slideRight fixed z-50 right-20 bottom-20 left-20 bg-mango p-10 rounded sans shadow-lg max-w-[355px] text-body-sm font-grotesk-bold',
                        'md:left-auto md:bottom-auto md:w-[335px]',
                        topMarginClass,
                        extendedStyles?.marginBottom
                    ),
                },
            }}
        >
            {copy}
        </SnackbarUnstyled>
    );
}

Toast.propTypes = {
    autoHideDuration: PropTypes.number,
    copy: PropTypes.node.isRequired,
    extendedStyles: PropTypes.shape({ marginBottom: PropTypes.string }),
    handleClose: PropTypes.func.isRequired,
    nanoBannerVisible: PropTypes.bool,
    open: PropTypes.bool.isRequired,
};

Toast.defaultProps = {
    autoHideDuration: 6000, // six seconds seems reasonable
    extendedStyles: {},
    nanoBannerVisible: false,
};
export default Toast;
